import { useState, type FormEvent } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/daiiuprp14a1h3mr74v0';

export default function SubscribeForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const guard = String(formData.get('website_alt') || '').trim();
    if (guard.length > 0) {
      setStatus('success');
      setMessage('订阅成功，之后就等着更新推送吧。');
      return;
    }

    formData.delete('website_alt');
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (typeof value === 'string' && value.trim() === '') return;
      params.append(key, String(value));
    });

    setStatus('submitting');
    setMessage('');

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();

      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';

      const isSpam = String(serverMsg).toLowerCase().includes('spam');
      const isOk = response.ok && parsed?.code === 'OK' && !isSpam;

      if (isOk) {
        setStatus('success');
        setMessage('订阅成功，之后就等着更新推送吧。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(serverMsg ? `提交失败：${serverMsg}` : '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，提交失败，请稍后重试。');
    }
  };

  return (
    <section id="subscribe" className="w-full bg-primary-50 border-y border-primary-200/60 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 max-w-3xl mx-auto text-center">
        <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-700 mb-4">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-notification-3-line" />
          </span>
          订阅更新
        </span>
        <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
          之后不用再一家一家地试
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto">
          留下邮箱，索引更新时会通知你一声。只发参考清单的变化，不发无关内容。
        </p>

        <form
          data-readdy-form
          id="daiiuprp14a1h3mr74v0"
          onSubmit={handleSubmit}
          className="mt-9 w-full flex flex-col sm:flex-row items-stretch gap-3 max-w-xl mx-auto"
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="field-guard-note"
          />
          <label htmlFor="subscribe-email" className="field-guard-note">
            请勿填写此栏
          </label>
          <input
            id="subscribe-email"
            type="email"
            name="email"
            required
            placeholder="你的邮箱地址"
            className="flex-1 px-4 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/60"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {status === 'submitting' ? '提交中…' : '订阅更新'}
          </button>
        </form>

        {status !== 'idle' && status !== 'submitting' && message && (
          <p
            className={`mt-4 text-sm ${
              status === 'success' ? 'text-accent-700' : 'text-primary-700'
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}